import "../../../styles/allNotificationsModal.scss";

import Icon, {iconColor, iconTypes} from "./Icon.jsx";

import { Localization } from "../util/localization.jsx";
import Modal from "./Modal.jsx";
import PropTypes from "prop-types";
import React from "react";
import ReactMarkdown from "react-markdown";
import { createSerializer } from "../util/flowControl";
import moment from "moment";

class Notification extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        if (this.props.notification && !this.props.notification.confirmedDate && !this.props.notification.displayPopup) {
            // If a notification which isn't a popup (and needs an explicit confirm action) is dismissed, mark it as read
            this.props.markNotificationAsConfirmed(this.props.notification.notificationId);
        }
    }

    render() {
        const {
            localization,
            notification: {
                body,
                confirmedDate,
                fromDate,
                subject,
                dismissedOnClient
            }
        } = this.props;

        const unread = (confirmedDate == null) && !dismissedOnClient;
        const icon = iconTypes.checkboxChecked;
        const now = moment();
        const diff = Math.max(0, now.diff(fromDate));

        let timeAgo;
        if (diff < 15 * 60 * 1000) {
            timeAgo = localization.text("menu", "now");
        } else if (diff < (60 * 60 * 1000)) {
            timeAgo = localization.text("menu", "xMinutesAgo", {minutes: moment.duration(diff).minutes()});
        } else if (diff < (24 * 60 * 60 * 1000)) {
            timeAgo = localization.text("menu", "xHoursAgo", {hours: moment.duration(diff).hours()});
        } else {
            timeAgo = <React.Fragment><div>{fromDate.format("D.M.YYYY")}</div></React.Fragment>;
        }

        return (
            <div className={unread ? "notification dropdown-menu-item unread" : "notification dropdown-menu-item"}>
                <Icon type={icon} className="dropdown-menu-item-icon"/>
                <div className={"noselect"} >
                    <div className="dropdown-menu-item-align">
                        <div className="dropdown-menu-item-text">
                            {subject}
                        </div>
                        <div className="dropdown-menu-right-text">
                            {timeAgo}
                        </div>
                    </div>
                    <div className="dropdown-menu-item-body">
                        <ReactMarkdown source={body}/>
                    </div>
                </div>
            </div>
        );
    }
}

Notification.propTypes = {
    localization: Localization.propTypes.isRequired,
    markNotificationAsConfirmed: PropTypes.func.isRequired,
    notification: PropTypes.object.isRequired
};

export default class AllNotificationsModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.modalRef = React.createRef();

        this.serializer = createSerializer();
        this.state = {
            skipped: 0,
            hasMore: true
        };

        const loadMore = async () => {
            try {
                if (this.state.hasMore) {
                    const notifications = await this.props.loadNotifications(false, this.state.skipped, 25);
                    this.setState({
                        skipped: this.state.skipped + 25,
                        hasMore: notifications.length >= 25
                    });
                }
            } catch (_) {
                this.setState({
                    hasMore: false
                });
            }   
        };

        this.serializedLoadMore = () => {
            this.serializer(loadMore);
        };

        this.onCloseModal = () => {};
        
        this.closeModal = (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.props.setModal(null);
        };
    }

    componentDidMount() {
        this.checkLoadMore = setInterval(() => {
            if (this.state.hasMore && this.modalRef.current) {
                const element = this.modalRef.current;
                if ((element.scrollHeight - element.scrollTop - element.clientHeight) < 200) {
                    this.serializedLoadMore();
                }
            }
        }, 500);
        this.serializedLoadMore();
    }

    componentWillUnmount() {
        if (this.checkLoadMore) {
            clearInterval(this.checkLoadMore);
        }
    }

    render() {
        const {
            localization,
            markNotificationAsConfirmed,
            groupedNotifications
        } = this.props;

        return (
            <Modal onCloseModal={this.onCloseModal} hideCard={true}>
                <div className="all-notifications-header">
                    <div className="all-notifications-title">
                        {localization.text("menu", "notifications")}
                    </div>
                    <button className="btn icon" onClick={this.closeModal}><Icon type={iconTypes.x} color={iconColor.red}/>{localization.text("menu", "close")}</button>
                </div>
                <div className="all-notifications-modal card-default" ref={this.modalRef}>
                    {groupedNotifications.map((group, idx) => (
                        <React.Fragment key={idx}>
                            <div className="notification-time-ago">{group.yearsAgo > 0 ? localization.text("menu", "xYearsAgo", {years: group.yearsAgo}) : (group.monthsAgo > 0 ? localization.text("menu", "xMonthsAgo", {months: group.monthsAgo}) : group.daysAgo > 0 ? localization.text("menu", "xDaysAgo", {days: group.daysAgo}) : localization.text("menu", "today"))}</div>
                            {group.notifications.map(notification => (
                                <Notification key={notification.notificationId} notification={notification} localization={localization} markNotificationAsConfirmed={markNotificationAsConfirmed}/>
                            ))}
                        </React.Fragment>
                    ))}
                </div>
            </Modal>
        );
    }
}

AllNotificationsModal.propTypes = {
    groupedNotifications: PropTypes.array.isRequired,
    localization: Localization.propTypes.isRequired,
    markNotificationAsConfirmed: PropTypes.func.isRequired,
    loadNotifications: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired
};